import { useMutation, useQuery } from '@tanstack/react-query'
import { instance } from '../instance'

export interface IFetchPlansFilters extends Partial<Filters> {
  network: 'mtn' | 'glo'
}
export const useFetchPlans = (filters: IFetchPlansFilters) => {
  const fetchAllPlans = async (): Promise<FetchPlanResponse[]> => {
    const response = await instance.get(
      `/admin-dashboard/plan?searchTerm=${filters?.searchTerm}&pageNumber=${
        filters?.pageNumber
      }&pageSize=${filters?.pageSize || 10}&network=${
        filters.network
      }&download=${filters.download}`,
    )
    return response.data.data as FetchPlanResponse[]
  }
  const queryApi = useQuery({
    queryKey: ['fetch all plans', filters],
    queryFn: fetchAllPlans,
  })
  return queryApi
}
export const useDownloadPlans = (filters: IFetchPlansFilters) => {
  const fetchAllPlans = async () => {
    const response = await instance.get(
      `/admin-dashboard/plan?searchTerm=${filters?.searchTerm}&pageNumber=${
        filters?.pageNumber
      }&pageSize=${filters?.pageSize || 10}&network=${
        filters.network
      }&download=true`,
      {
        responseType: 'blob',
      },
    )
    return response.data
  }
  const mutateApi = useMutation({
    mutationKey: ['fetch all plans', filters],
    mutationFn: fetchAllPlans,
  })
  return mutateApi
}

export const useCreatePlans = () => {
  const createNewPlans = async (
    payload: CreatePlanPayload,
  ): Promise<CreateRolesResponse> => {
    const response = await instance.post(`/admin-dashboard/plan`, payload)
    return response.data
  }
  const mutateAPI = useMutation({
    mutationKey: ['Create new plans'],
    mutationFn: (payload: CreatePlanPayload) => createNewPlans(payload),
  })
  return mutateAPI
}
